import styled from "@emotion/styled";

const Input = styled.input`
  padding: 6px;
  border: 1px solid #e2e4e7;
  border-radius: 3px;
  transition: border-color 0.3s;
  outline: none;

  &:hover {
    border-color: #1976d2;
  }

  &:focus {
    border-color: #1976d2;
  }
`;

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.2;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  padding: 0px 0px 0px 30px;
  margin: 0px 0px 15px 0px;
`;

const Children = styled.div`
  flex: 1.2;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
`;

const SC = {
  Input,
  Label,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
};

export default SC;
